import React from 'react';
import usePrefersReducedMotion from './usePrefersReducedMotion';
import './AdminSkeleton.css';

function renderTable(rows, columns) {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <div key={`row-${rowIndex}`} className="au-skeleton__table-row">
      {Array.from({ length: columns }).map((__, columnIndex) => (
        <span key={`cell-${rowIndex}-${columnIndex}`} className="au-skeleton__block au-skeleton__block--table" />
      ))}
    </div>
  ));
}

function renderSidebar() {
  return (
    <>
      <span className="au-skeleton__block au-skeleton__block--label" />
      <span className="au-skeleton__block au-skeleton__block--row" />
      <span className="au-skeleton__block au-skeleton__block--row" />
      <span className="au-skeleton__block au-skeleton__block--row" />
      <span className="au-skeleton__block au-skeleton__block--label au-skeleton__block--label-gap" />
      <span className="au-skeleton__block au-skeleton__block--row" />
      <span className="au-skeleton__block au-skeleton__block--row" />
    </>
  );
}

function renderToolbar() {
  return (
    <div className="au-skeleton__toolbar">
      <span className="au-skeleton__block au-skeleton__block--toolbar-label" />
      <div className="au-skeleton__toolbar-actions">
        <span className="au-skeleton__block au-skeleton__block--toolbar-button" />
        <span className="au-skeleton__block au-skeleton__block--toolbar-button" />
      </div>
    </div>
  );
}

function renderCard(rows) {
  return Array.from({ length: rows }).map((_, index) => (
    <div key={`card-${index}`} className="au-skeleton__card">
      <span className="au-skeleton__block au-skeleton__block--card-title" />
      <span className="au-skeleton__block au-skeleton__block--card-line" />
      <span className="au-skeleton__block au-skeleton__block--card-line is-short" />
      <span className="au-skeleton__block au-skeleton__block--toolbar-button" />
    </div>
  ));
}

/**
 * @param {{
 *   variant?: 'table' | 'sidebar' | 'toolbar' | 'card',
 *   rows?: number,
 *   columns?: number,
 *   className?: string
 * }} props
 */
function AdminSkeleton({
  variant = 'table',
  rows = 10,
  columns = 4,
  className = '',
}) {
  const reducedMotion = usePrefersReducedMotion();

  let content = renderTable(rows, columns);
  if (variant === 'sidebar') {
    content = renderSidebar();
  } else if (variant === 'toolbar') {
    content = renderToolbar();
  } else if (variant === 'card') {
    content = renderCard(rows);
  }

  return (
    <div
      className={`au-skeleton au-scope au-skeleton--${variant}${reducedMotion ? ' is-reduced-motion' : ''}${className ? ` ${className}` : ''}`}
      aria-busy="true"
      style={variant === 'table' ? { '--au-skeleton-columns': columns } : undefined}
    >
      <span className="au-visually-hidden">Loading</span>
      {content}
    </div>
  );
}

export default AdminSkeleton;
